// File: /src/components/clients/ClientsGridView.js

import React from 'react';
import ClientsGrid from '../ClientsGrid';

const ClientsGridView = ({
	clients,
	selectedClients,
	cardColors,
	onToggleClient,
	onColorChange,
	onOpenClientModal,
}) => (
	<ClientsGrid
		clients={clients}
		selectedClients={selectedClients}
		cardColors={cardColors}
		toggleSelectClient={onToggleClient}
		handleColorChange={onColorChange}
		openClientModal={onOpenClientModal}
	/>
);

export default ClientsGridView;
